import { getThemeColors } from '../../utils/chartTheme';

export const getOptions = () => {
    const tc = getThemeColors();
    return {
        maintainAspectRatio: true,
        responsive: true,
        title: {
            display: true,
            text: ''
        },
        plugins: {
            tooltip: {
                callbacks: {
                    label: function (context) {
                        let value = context.chart.data.datasets[context.datasetIndex].data[context.dataIndex];
                        let date = context.chart.data.labels[context.dataIndex];
                        let newlabel = value + ' kWh im ' + date;
                        return [newlabel]
                    }
                }
            },
            datalabels: {
                anchor: 'center',
                color: function (context) {
                    return '#fff';
                },
                align: 'center',
                display: true,   // GRUNDREGEL: alle Punkte sichtbar
                formatter: Math.round,
                font: {
                    weight: 'normal'
                }
            }
        },
        scales: {
            x: {
                stacked: true,
                grid: { color: tc.gridColor },
                ticks: {
                    autoSkip: false,
                    color: tc.textColor
                },
                title: {
                    display: true,
                    text: 'kWh',
                    color: tc.textColor
                }
            },
            y: {
                stacked: true,
                grid: { color: tc.gridColor },
                ticks: {
                    beginAtZero: true,
                    color: tc.textColor
                },
                title: {
                    display: true,
                    text: 'Monat',
                    color: tc.textColor
                }
            }
        }
    };
};
